module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/master/district/distict-grid/distict-grid.component.css
// module id = ./src/app/pages/master/district/distict-grid/distict-grid.component.css
// module chunks = main